<sc-loading-spinner [fitHeight]="true" [isLoading]="isLoading">
  <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" class="no-field-space">
    <div>
      <form [formGroup]="form">
        <sc-flex>
          <mat-checkbox class="spaceBehind" formControlName="showAllData" name="showAllData">
            {{'show all data'| translate:['reporting.list-export.filter.showAllData',
            translationService.language]}}
          </mat-checkbox>
          <sc-content-spacer></sc-content-spacer>
          <mat-form-field appearance="fill" class="spaceBehind date-field">
            <mat-label>{{'registration from'| translate:['reporting.list-export.filter.from',
              translationService.language]}}</mat-label>
            <input matInput formControlName="dateFrom" [matDatepicker]="picker1" type="date-local">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <sc-content-spacer></sc-content-spacer>
          <mat-form-field appearance="fill" class="spaceBehind date-field">
            <mat-label>{{'to'| translate:['reporting.list-export.filter.to', translationService.language]}}
            </mat-label>
            <input matInput formControlName="dateUntil" [matDatepicker]="picker2" type="date-local">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
        </sc-flex>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <sc-flex>
          <app-structure-node-selection class="spaceBehind"
            (selectedStructureChanged)="onSelectedStructureChanged($event)" [selectedNode]="selectedStructureNode">
          </app-structure-node-selection>
          <sc-content-spacer></sc-content-spacer>
          <mat-form-field appearance="fill" class="extended-width spaceBehind">
            <mat-label>{{'content'| translate:['reporting.list-export.filter.content',
              translationService.language]}}
            </mat-label>
            <input matInput formControlName="query">
          </mat-form-field>
          <sc-content-spacer></sc-content-spacer>
          <button (click)="updateList()" [disabled]="isUpdateListDisabled()" mat-stroked-button button
            class="spaceBehind">{{'show'|
            translate:['reporting.list-export.action.show', translationService.language]}}</button>
          <sc-content-spacer></sc-content-spacer>
          <mat-form-field>
            <mat-label>{{ 'Export type' | translate: ['reporting.list-export.export-type',
              translationService.language]}}</mat-label>
            <mat-select formControlName="exportType" [value]="selectedExportType">
              <mat-option *ngFor="let o of exportTypes" value="{{o}}" select>
                {{o | translate: ['reporting.list-export.export-type.' + o, translationService.language]}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <sc-content-spacer></sc-content-spacer>
          <button (click)="createExcel()" [disabled]="isCreateDisabled()" mat-flat-button
            class="spaceBehind">{{'export'|
            translate:['reporting.list-export.action.export',
            translationService.language]}}</button>
        </sc-flex>
      </form>
    </div>
    <sc-content-spacer [vertical]="true"></sc-content-spacer>
    <sc-flex-fitting-content [vertical]="true">
      <sc-content-area [fitHeight]="true">
        <sc-scroll-pane>
          <table mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="hint">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let transport"> <i (click)="showTransportDetails(transport)"
                  class="station-details-button fa-light fa-info-circle"></i> </td>
            </ng-container>
            <ng-container matColumnDef="registrationDate">
              <th mat-header-cell *matHeaderCellDef>{{'registration date'|
                translate:['tmc-yard.entity.transport.registration-date', translationService.language]}}
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.registrationDate}} </td>
            </ng-container>
            <ng-container matColumnDef="hasTimeSlot">
              <th mat-header-cell *matHeaderCellDef>{{'has timeslot'|
                translate:['tmc-yard.entity.transport.has-timeframe', translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.hasTimeSlot}} </td>
            </ng-container>
            <ng-container matColumnDef="timeSlotPlannedStart">
              <th mat-header-cell *matHeaderCellDef>{{'timeslot planned start'|
                translate:['tmc-yard.entity.transport.planning-date',
                translationService.language]}}
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.timeSlotPlannedStart}} </td>
            </ng-container>
            <ng-container matColumnDef="timeSlotDelay">
              <th mat-header-cell *matHeaderCellDef>{{'timeslot delay'|
                translate:['tmc-yard.entity.transport.time-slot-delay', translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.timeSlotDelay}} </td>
            </ng-container>
            <ng-container matColumnDef="processingTime">
              <th mat-header-cell *matHeaderCellDef>{{'processing time'|
                translate:['tmc-yard.entity.transport.processing-time', translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.processingTime}} </td>
            </ng-container>
            <ng-container matColumnDef="waitingTime">
              <th mat-header-cell *matHeaderCellDef>{{'waiting time'|
                translate:['tmc-yard.entity.transport.waiting-time', translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.waitingTime}} </td>
            </ng-container>
            <ng-container matColumnDef="wasDeleted">
              <th mat-header-cell *matHeaderCellDef>{{'was deleted'|
                translate:['tmc-yard.entity.transport.was-deleted', translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.wasDeleted}} </td>
            </ng-container>
            <ng-container matColumnDef="deletionCause">
              <th mat-header-cell *matHeaderCellDef>{{'cancellation cause'|
                translate:['tmc-yard.entity.transport.cancellation-cause', translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.deletionCause}} </td>
            </ng-container>
            <ng-container matColumnDef="wasPaused">
              <th mat-header-cell *matHeaderCellDef>{{'was paused'|
                translate:['tmc-yard.entity.transport.was-paused', translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.wasPaused}} </td>
            </ng-container>
            <ng-container matColumnDef="totalTimePaused">
              <th mat-header-cell *matHeaderCellDef>{{'total time paused'|
                translate:['tmc-yard.entity.transport.total-time-paused', translationService.language]}}
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.totalTimePaused}} </td>
            </ng-container>
            <ng-container matColumnDef="maxAllowedProcessingTime">
              <th mat-header-cell *matHeaderCellDef>{{'planned processing duration'|
                translate:['tmc-yard.entity.transport.planned-processing-duration',
                translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.maxAllowedProcessingTime}} </td>
            </ng-container>
            <ng-container matColumnDef="carrier">
              <th mat-header-cell *matHeaderCellDef>{{'carrier'| translate:['tmc-yard.entity.transport.carrier',
                translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.carrier}} </td>
            </ng-container>
            <ng-container matColumnDef="string1">
              <th mat-header-cell *matHeaderCellDef>{{'string 1'| translate:['tmc-yard.entity.transport.string-1',
                translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.string1}} </td>
            </ng-container>
            <ng-container matColumnDef="string2">
              <th mat-header-cell *matHeaderCellDef>{{'string 2'| translate:['tmc-yard.entity.transport.string-2',
                translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.string2}} </td>
            </ng-container>
            <ng-container matColumnDef="phone">
              <th mat-header-cell *matHeaderCellDef>{{'phone'| translate:['tmc-yard.entity.transport.phone',
                translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.phone}} </td>
            </ng-container>
            <ng-container matColumnDef="transportStatus">
              <th mat-header-cell *matHeaderCellDef>{{'transport status'|
                translate:['tmc-yard.entity.transport.transport-status', translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.transportStatus}} </td>
            </ng-container>
            <ng-container matColumnDef="processingPositionsCount">
              <th mat-header-cell *matHeaderCellDef>{{'processing positions count'|
                translate:['tmc-yard.entity.transport.processing-positions-count',
                translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.processingPositionsCount}} </td>
            </ng-container>
            <ng-container matColumnDef="messagingType">
              <th mat-header-cell *matHeaderCellDef>{{'messaging type'|
                translate:['tmc-yard.entity.transport.messaging-type', translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.activeMessagingChannels}} </td>
            </ng-container>
            <ng-container matColumnDef="smartphoneLent">
              <th mat-header-cell *matHeaderCellDef>{{'smartphone lent'|
                translate:['tmc-yard.entity.transport.smartphone-lent', translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.smartphoneLent}} </td>
            </ng-container>
            <ng-container matColumnDef="transportOptionMarks">
              <th mat-header-cell *matHeaderCellDef> {{'transport option marks'|
                translate:['tmc-yard.entity.transport.options',
                translationService.language]}}
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.transportOptionMarks}} </td>
            </ng-container>
            <ng-container matColumnDef="cargoOfRoutingPositions">
              <th mat-header-cell *matHeaderCellDef> {{'cargo'|
                translate:['tmc-yard.entity.transport.cargo',
                translationService.language]}} </th>
              <td mat-cell *matCellDef="let transport"> {{transport.cargoOfRoutingPositions}} </td>
            </ng-container>
            <ng-container matColumnDef="processingStart">
              <th mat-header-cell *matHeaderCellDef> {{'start'|
                translate:['tmc-yard.entity.transport.start', translationService.language]}}
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.processingStart}} </td>
            </ng-container>
            <ng-container matColumnDef="planningDate">
              <th mat-header-cell *matHeaderCellDef> {{'planning date'|
                translate:['tmc-yard.entity.transport.planning-date', translationService.language]}} </th>
              <td mat-cell *matCellDef="let transport"> {{transport.planningDate}} </td>
            </ng-container>
            <ng-container matColumnDef="planningType">
              <th mat-header-cell *matHeaderCellDef> {{'planning type'|
                translate:['tmc-yard.entity.transport.planning-type', translationService.language]}} </th>
              <td mat-cell *matCellDef="let transport"> {{transport.planningType}} </td>
            </ng-container>
            <ng-container matColumnDef="preloading">
              <th mat-header-cell *matHeaderCellDef> {{'preloading'|
                translate:['tmc-yard.entity.transport.preloading', translationService.language]}} </th>
              <td mat-cell *matCellDef="let transport"> {{transport.preloading}} </td>
            </ng-container>
            <ng-container matColumnDef="delayedLeave">
              <th mat-header-cell *matHeaderCellDef> {{'styas on yard'|
                translate:['tmc-yard.entity.transport.delayed-leave', translationService.language]}} </th>
              <td mat-cell *matCellDef="let transport"> {{transport.delayedLeave}} </td>
            </ng-container>
            <ng-container matColumnDef="numberPlate">
              <th mat-header-cell *matHeaderCellDef> {{'numnber plate'|
                translate:['tmc-yard.entity.transport.numberplate', translationService.language]}} </th>
              <td mat-cell *matCellDef="let transport"> {{transport.numberPlate}} </td>
            </ng-container>
            <ng-container matColumnDef="trailerNumberPlate">
              <th mat-header-cell *matHeaderCellDef> {{'trailer number plate'|
                translate:['tmc-yard.entity.transport.trailer-number-plate', translationService.language]}}
              </th>
              <td mat-cell *matCellDef="let transport"> {{transport.trailerNumberPlate}} </td>
            </ng-container>
            <ng-container matColumnDef="entrance">
              <th mat-header-cell *matHeaderCellDef> {{'entrance'| translate:['tmc-yard.entity.transport.entrance',
                translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.entrance}} </td>
            </ng-container>
            <ng-container matColumnDef="leave">
              <th mat-header-cell *matHeaderCellDef> {{'leave'| translate:['tmc-yard.entity.transport.leaveDate',
                translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.leave}} </td>
            </ng-container>
            <ng-container matColumnDef="orderReference">
              <th mat-header-cell *matHeaderCellDef> {{'orderReference'|
                translate:['tmc-yard.entity.transport.order-reference',
                translationService.language]}}</th>
              <td mat-cell *matCellDef="let transport"> {{transport.orderReference}} </td>
            </ng-container>
            <ng-container matColumnDef="hide">
              <th mat-header-cell *matHeaderCellDef> {{'hide'| translate:['reporting.list-export.table.column.hide',
                translationService.language]}} </th>
              <td mat-cell *matCellDef="let transport">
                <mat-checkbox (change)="toggleIgnore(transport)" [(ngModel)]="transport.ignore"></mat-checkbox>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
            <tr mat-row *matRowDef="let transport; columns: columnsToDisplay"></tr>
          </table>
        </sc-scroll-pane>
      </sc-content-area>
    </sc-flex-fitting-content>
  </sc-flex>
</sc-loading-spinner>